import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /dist/src/app/ui/page-not-found/page-not-found.component.ts